import React from 'react';
import { Chip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { RegionsType } from 'src/types/SchoolType';


interface Props {
  user_area?: RegionsType;
  isModify?: boolean;
  setUser_area?: React.Dispatch<React.SetStateAction<RegionsType>>;
}

const ManageRegionMyinfo = ({ user_area, isModify, setUser_area }: Props) => {

  const handleExclude = (province: string, district: string) => {
    if (!user_area) return;

    const updated = { ...user_area };
    updated[province] = updated[province].filter((d) => d !== district);

    if (updated[province].length === 0) {
      delete updated[province];
    }
    setUser_area?.(updated);
  };

  return (
    <div>
      {Object.entries(user_area ?? {}).flatMap(([province, districts]) =>
        districts.map((district, idx) => (
          <Chip
            key={`${province}-${district}-${idx}`}
            label={`${province} ${district}`}
            {...(!isModify && {
              onDelete: () => handleExclude(province, district),
              deleteIcon: <CloseIcon />,
            })}
            sx={{ backgroundColor: 'rgba(245,245,245,1)', margin: '5px' }}
          />
        ))
      )}
    </div>
  );
};

export default ManageRegionMyinfo;